import { Injectable } from '@angular/core';
import { BasecrudService } from 'src/app/shared/basecrud.service';
import { HttpClient } from '@angular/common/http';
import { Helper } from 'src/app/shared/Helper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService extends BasecrudService {
  constructor(http: HttpClient) {
    super(http, "produto");
  }
}
